import type {
  CONTRACT_TYPE,
  ContractRequestData,
  ContractResponse,
} from '@/features/Contract/types';
import type { HttpClientResponse } from '@/services/api/HttpClient';
import { HttpService } from '@/services/api/HttpService';

export class ContractHttpService extends HttpService {
  generateContract(
    data: ContractRequestData,
    type: CONTRACT_TYPE,
  ): HttpClientResponse<ContractResponse> {
    return this.httpClient.post(`antrag/${type}`, {
      data,
    });
  }
}
